/**
 * Use this for `subType` of the main entity of the semantic model to explicitly
 * mark the model as an application profile.
 *
 * @see {@link isModelProfile}
 */
export const SEMANTIC_MODEL_APPLICATION_PROFILE_SUBTYPE = "https://w3id.org/dsv#ApplicationProfile";
//# sourceMappingURL=profile.js.map